export abstract class IWhatsappApi {
	abstract sendMessage(phone: string, message: string): void;
}
